import './styles/app.scss'
import './styles/preloader.scss'
import './styles/loader.scss'
import './styles/animation.scss'

import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { BrowserRouter } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import Favicon from 'react-favicon'
import Moment from 'react-moment'
import moment from 'moment'
import 'moment/locale/ru'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import ruLocale from 'date-fns/locale/ru'
import { ErrorFallback } from './pages'
import { theme } from './theme/theme'
import store from './store'
import App from './app/app'

import { img } from './imgs'

moment.locale('ru')
moment.defaultFormat = 'DD.MM.YYYY'
Moment.globalLocale = 'ru'
Moment.globalFormat = 'DD.MM.YYYY'

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/">
      <ThemeProvider theme={theme}>
        <Favicon url={img.favicon} />
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ruLocale}>
            <App />
          </LocalizationProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root-app')
)
